const STATUS = {
    planning: { bg: "#2979FF", label: "PLANNING" },
    working: { bg: "#FFEA00", label: "WORKING" },
    stuck: { bg: "#FF1744", label: "STUCK" },
    done: { bg: "#00E676", label: "DONE" },
    "on-hold": { bg: "#B0B0B0", label: "ON HOLD" },
};

export default function StatusPill({ value, onClick, className = "" }) {
    const s = STATUS[value] || STATUS.planning;
    return (
        <button
            onClick={onClick}
            className={`inline-flex items-center justify-center px-2 py-1 min-w-[80px] font-mono text-[10px] tracking-[0.18em] font-bold text-black hover:opacity-90 transition-opacity ${className}`}
            style={{ backgroundColor: s.bg }}
            type="button"
        >
            {s.label}
        </button>
    );
}

export const STATUS_LIST = Object.keys(STATUS);
export const STATUS_META = STATUS;
